import { createFileRoute } from '@tanstack/react-router';
import { call } from '@hlt/web-kit/api';
import { publicIdParam, resolveResource } from '@/app/route-ids';
import { DesignerPage } from '@/features/analytics/designer/designer-page';

export const Route = createFileRoute('/_app/w/$workspaceId/analytics/$pageId/edit')({
    params: publicIdParam('pageId'),
    staticData: {
        crumbs: [
            { label: 'shell.analytics', to: '/w/$workspaceId/analytics' },
            { label: 'shell.crumbPage', to: '/w/$workspaceId/analytics/$pageId' },
            { label: 'shell.crumbEdit' },
        ],
    },
    beforeLoad: async ({ context, params, location }) =>
        await resolveResource({
            ref: params.pageId,
            collection: 'analytics',
            location,
            read: async () =>
                await call('getPageDraft', { params: { ...context.workspaceScope, pageId: params.pageId } }),
        }),
    component: function AnalyticsDesignerRoute() {
        const { workspaceScope } = Route.useRouteContext();
        const { pageId } = Route.useParams();
        return <DesignerPage key={pageId} scope={workspaceScope} pageId={pageId} />;
    },
});
